import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TranslateService } from '@devinforius/super-compos-17';
import { ToastrService } from 'ngx-toastr';
import { ApiService } from 'src/app/core/services/api.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { DataService } from 'src/app/core/services/data.service';
import { Global_Class } from 'src/app/shared/models/global';
import { Tabs } from '@devinforius/super-compos-17/lib/models/tabs';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { Subscription } from 'rxjs';
import { ITableColumn, ITableConfig } from '@devinforius/super-compos-17';
import { ExportDelibeMandatairesListDatas } from 'src/app/shared/models/export/export-delibe-mandataire-list-datas';
import moment from 'moment';
import { IGlobalElements } from 'src/app/shared/models/common/IGlobalElements';
import { ExportDelibeMandataires } from 'src/app/shared/models/export/export-delibe-mandataires';
import { StatusExportIDelibeMandataire } from 'src/app/shared/models/export/status-export-delibe-mandataire';
import { CitoyenPointToExport, PointForPointToExport } from 'src/app/shared/models/export-citoyen-mandataire/export';

@Component({
  selector: 'app-export-idelibe-modal',
  templateUrl: './export-idelibe-modal.component.html',
  styleUrls: ['./export-idelibe-modal.component.scss'],
})
export class ExportIdelibeModalComponent implements OnInit {
  @Input() openDialogExport: boolean = false;
  @Input() typeExport: string = '';
  @Input() exportItems: ExportDelibeMandataires;
  @Input() meetingId: number;
  @Input() iAdminUsers: any;
  @Output() closeModal = new EventEmitter<boolean>();
  modalHeader = {
    title: 'Export',
    iconTitle: 'bi bi-send',
    showNotification: false,
    showParameters: false,
    closable: true,
  };
  modalParams = { 
    isDraggable: true,
    isResizable: true,
    isModal: true,
    style:{ height: '80vh', width: '50vw', minWidth: '50vw', maxWidth: '50vw' }
  };
  public columnsExportCitoyenPoints: Array<ITableColumn> = [
    {
      field: 'ordreReel',
      header: 'Ordre Réel',
      width: '10%',
      export: (value, item) => {
        // if (item.type && item.type === "event") {
        //   return "🏴";
        // } else {
        if (!isNaN(item.ordreReel) && item.ordreReel !== null) return item.ordreReel;
        // }
      },
    },
    {
      field: 'ordreDocument',
      header: 'Ordre Document',
    },
    {
      field: 'objetSynthese',
      width: '50%',
      header: 'Titre',
      tooltip: (item) => {
        if (item && item.objetSynthese) {
          return item.objetSynthese;
        }
      },
      export: (value, item) => {
        if (item && item.objetSynthese) {
          return item.objetSynthese;
        }
      },
    },
    {
      field: 'confidentielLabel',
      header: 'Confidentiel',
      format: (value, item) => {
        if (item.confidentiel === true) {
          return '<b style="color: #07E299;"><i class="bi bi-check-circle-fill"></i></b>';
        } else if (item.confidentiel === false) {
          return '<b style="color: #FF5671;"></b>';
        } else if (item.confidentiel === null) {
          return '';
        }
      },
      export: (value, item) => {
        if (item.confidentiel === true) {
          return '<b style="color: #07E299;"><i class="bi bi-check-circle-fill"></i></b>';
        } else if (item.confidentiel === false) {
          return '<b style="color: #FF5671;"><i class="bi bi-x-circle-fill"></i></b>';
        } else if (item.confidentiel === null) {
          return '';
        }
      },
    },
    {
      field: 'typePoint',
      header: 'Type',
      export: (value) => {
        return value;
      },
    },
  ];
  public columnsHistoricExportDelibeMandataire: Array<ITableColumn> = [
    {
      field: 'exportDateTime',
      header: 'Date et heure',
      format: (value) => {
        if (value) {
          return moment(value).format(this.translate.translate('format.formattedDateFull'));
        } else {
          return '/';
        }
      },
    },
    {
      field: 'userName',
      header: 'Exporté par',
    },
    {
      field: 'commentaires',
      header: 'Commentaire',
    },
    {
      field: 'statusLabelTranslated',
      header: 'Statut',
      format: (value, item) => {
        return this.translate.translate(item.statusLabel);
      },
    },
    {
      field: 'errorMessages',
      header: "Type d'erreur(s)",
      format: (value, item) => {
        if (item.jsonData) {
          return item.jsonErrors.join(', ');
        } else {
          return '/';
        }
      },
    },
  ];
  imgPath: string = '';
  title: string = '';
  dateExport: Date = new Date();
  tag: string = '';
  public globalElement: Global_Class;
  public statusExport: StatusExportIDelibeMandataire[];
  public activeTab: number = 0;
  public tabs: Array<Tabs> = [
    { title: 'Export', active: this.activeTab === 0, slug: 'export', icon: '' },
    { title: 'Historique', active: this.activeTab === 1, slug: 'historic', icon: '' },
  ];
  public formExportMandataire = new UntypedFormGroup({
    commentaires: new UntypedFormControl(),
  });
  public notifyUserSubscription: Subscription;
  public listOfPointsCitoyenExportFiltered: PointForPointToExport[] = [];
  public tableConfigurations: ITableConfig;
  public exportItemsHistoricMandataire: Array<ExportDelibeMandatairesListDatas> = []; //* historic of exports in delibe Mandataire
  public exportItemsHistoricCitoyen: Array<ExportDelibeMandatairesListDatas> = []; //* historic of exports in delibe Citoyen

  constructor(
    public api: ApiService,
    public toastr: ToastrService,
    public translate: TranslateService,
    public spinner: NgxSpinnerService,
    public dataService: DataService,
  ) {}

  ngOnInit(): void {
    this.dataService.getGlobalElements.subscribe((res: IGlobalElements) => {
      this.globalElement = new Global_Class(res);
      if (this.globalElement.isLoaded()) {
        this.statusExport = this.globalElement?.configApp.seanceExportIDelibeStatutes;
      }
    });
    this.setInfoExport();
  }

  setConfigurationTable(): void {
    this.tableConfigurations = new ITableConfig({
      showPaginator: false,
      showColumnSelector: false,
      showForSelectionRow: false,
      isRowClickable: false,
      multiselect: false,
      viewSearch: false,
      resizableColumns: true,
      reorderableColumns: true,
      rowPerPageOptions: [10, 20, 50, 100, 500],
      height: '40vh',
      tableStyle: { width: '100%'}
    });
  }

  closeDialog(event?): void {
    this.openDialogExport = false;
    this.closeModal.emit(event);
  }

  setInfoExport(): void {
    const assetsPath = './assets/img/';
    this.setConfigurationTable();
    if(this.typeExport === 'mandataire') {
      this.modalHeader.title = 'Export Mandataires';
      this.imgPath = assetsPath + 'iDélibéMandataires.svg';
      this.title = 'Export Mandataires';
      this.getExportsMandataire();
    } else {
      this.modalHeader.title = 'Export Citoyens';
      this.imgPath = assetsPath + 'iDelibeCitoyenLogo.svg';
      this.title = 'Export Citoyens';
      this.exportNowCitoyen();
      this.getExportsCitoyen();
    }
  }

  tabChange(index) {
    if (index === 'export') {
      this.activeTab = 0;
    }
    if (index === 'historic') {
      this.activeTab = 1;
      this.typeExport === 'mandataire' ? this.getExportHistoricMandataire() : null;
    }
  }

  //* triggers the Delibe Mandataires export for the meeting
  exportMandataireNow() {
    this.spinner.show();
    this.api.exportMandataireNow(this.meetingId, this.formExportMandataire.value).subscribe(
      () => {
        this.closeDialog();
        this.toastr.success("Processus d'exportation lancé, vous recevrez un message une fois terminé");
        this.spinner.hide();
        this.getExportsMandataire();
      },
      () => {
        this.toastr.error("Une erreur est survenue lors de l'export.");
        this.getExportsMandataire();
      }
    );
  }

  //* Gets the infos to export
  getExportsMandataire() {
    this.exportItems = null;
      this.api.getExportsDelibeMandataire(this.meetingId).subscribe((res: any) => {
        this.exportItems = res;
        if (res.lastExport?.userId) {
          const userIndex = this.iAdminUsers.map((x) => +x.userId).indexOf(+res.lastExport.userId);
          this.exportItems.lastExport.userName = this.iAdminUsers[userIndex].contactForUser?.label;
          return true;
        }
      });
  }

  getExportsCitoyen() {
    this.exportItems = null;
    this.api.getExportsDelibeCitoyen(this.meetingId).subscribe((res: any) => {
      this.exportItems = res;
      if (res.lastExport?.userId) {
        const userIndex = this.iAdminUsers.map((x) => +x.userId).indexOf(+res.lastExport.userId);
        this.exportItems.lastExport.userName = this.iAdminUsers[userIndex].contactForUser?.label;
        return true;
      }
    });
  }

  exportCitoyenNow() {
    this.spinner.show();
    this.api.exportCitoyenNow(this.meetingId).subscribe(
      (res: any) => {
        this.toastr.success("Processus d'exportation lancé, vous recevrez un message une fois terminé");
        this.spinner.hide();
        this.getExportsCitoyen();
        this.closeDialog();
      },
      () => {
        this.toastr.error("Une erreur est survenue lors de l'export.");
        this.getExportsCitoyen();
      }
    );
  }

  exportNowCitoyen() {
    this.spinner.show();
    this.api.getExportCitoyenPoints(this.meetingId).subscribe((data: CitoyenPointToExport[]) => {
      this.listOfPointsCitoyenExportFiltered = data
        .filter((x) => x.isPointChecked)
        .map((x) => {
          x.point.pointFichiers = x.pointFichiers;
          x.point.ordreDocument = x.ordreDocument;
          x.point.ordreMatiere = x.ordreMatiere;
          x.point.ordreReel = x.ordreReel;
          const typePointFound = this.globalElement?.types_points_LV.find((type) => {
            return type.value == x.point.typeId;
          });
          if (typePointFound) {
            x.point.typePoint = typePointFound.label;
          } else {
            x.point.typePoint = 'Pas de type';
          }
          return x.point;
        });
      this.spinner.hide();
    });
  }

  getExportHistoricMandataire() {
    this.api.getExportsDelibeMandataire(this.meetingId).subscribe((res: any) => {
      this.exportItemsHistoricMandataire = res.histories;
      this.exportItemsHistoricMandataire.map((x) => {
        if (x.userId) {
          const userIndex = this.iAdminUsers.map((adminUsers) => +adminUsers.userId).indexOf(x.userId);
          x.userName = this.iAdminUsers[userIndex].label;
        }
        const statusLabelIndex = this.statusExport.map((x) => x.id).indexOf(x.statutId);
        if (statusLabelIndex) {
          x.statusLabel = this.statusExport[statusLabelIndex].label;
        }
        if (x.statutId === 5) {
          //Si le statut est en erreur
          const jsonData = JSON.parse(x.jsonData);
          x.jsonErrors = jsonData?.Errors?.map((x) => x.Message);
        }
      });
    });
  }

  //* gets the historic the all the exports
  getExportHistoricCitoyen() {
    this.api.getExportsDelibeCitoyen(this.meetingId).subscribe((res: any) => {
      this.exportItemsHistoricCitoyen = res.histories;
      this.exportItemsHistoricCitoyen.map((x) => {
        if (x.userId) {
          const userIndex = this.iAdminUsers.map((adminUsers) => +adminUsers.userId).indexOf(x.userId);
          x.userName = this.iAdminUsers[userIndex].label;
        }
        const statusLabelIndex = this.statusExport.map((x) => x.id).indexOf(x.statutId);
        if (statusLabelIndex) {
          x.statusLabel = this.statusExport[statusLabelIndex].label;
        }
        if (x.statutId === 5) {
          //Si le statut est en erreur
          const jsonData = JSON.parse(x.jsonData);
          x.jsonErrors = jsonData?.Errors?.map((x) => x.Message);
        }
      });
    });
  }

  getSeverity(statutId: number): string {
    switch (statutId) {
      case 1:
      case 2:
        return 'info';
      case 3:
        return 'success';
      case 4:
        return 'warning';
      case 5:
        return 'danger';
      default:
        return 'info';
    }
  }
}
